import React from "react";
import Places from "../components/widgets/Places/Places";
import QuoteSection from "../components/widgets/QuoteSection/QuoteSection";
import { useTranslatedTitle } from "../utils/utils";

const HistoryReading: React.FC = () => {
  useTranslatedTitle("title.historyReading");

  return (
    <>
      <QuoteSection />
      <Places />
    </>
  );
};

export default HistoryReading;
